import React from 'react';
import AppErrorBoundary from './AppErrorBoundary';

type Props = {
  children: React.ReactNode;
};

const RootErrorBoundary = ({ children }: Props) => <AppErrorBoundary resetOnTryAgain="reload">{children}</AppErrorBoundary>;

export default RootErrorBoundary;
